<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>

      <div class="tabs-container px-6 pt-6">
        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab label="Buy Number" icon-pack="feather" icon="icon-number" @click="$router.push('/reseller/anipool/addnum/buynum').catch(() => {})">            
          </vs-tab>
          <vs-tab label="Import" icon-pack="feather" icon="icon-info">            
          </vs-tab>
          <vs-tab label="Select from List" icon-pack="feather" icon="icon-share-2">            
          </vs-tab>
        </vs-tabs>
      </div>
      <div>
        <vs-textarea label="Add Number" v-model="textarea" height="500px"/>
      </div>
    </vx-card>
  </div>
</template>

<script>

// Store Module


export default {
  components: {
    
  }
}

</script>
